"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DateHelper = _interopRequireDefault(require("../../../../../../util/DateHelper"));

var _AppActiveSign = _interopRequireDefault(require("../../../../../../components/elements/AppActiveSign"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var UserInfo = /*#__PURE__*/function (_Component) {
  _inherits(UserInfo, _Component);

  function UserInfo() {
    _classCallCheck(this, UserInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserInfo).apply(this, arguments));
  }

  _createClass(UserInfo, [{
    key: "render",
    value: function render() {
      var device = this.props.device;
      return _react["default"].createElement("div", {
        className: "main"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "customers-info"
      }, _react["default"].createElement("div", {
        className: "customer-details"
      }, _react["default"].createElement("div", null, _react["default"].createElement("h2", {
        className: "customer-name"
      }, _react["default"].createElement("span", {
        className: "company"
      }, device.deviceOs)))), _react["default"].createElement("div", {
        className: "customers-main"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("div", {
        className: "padded"
      }, _react["default"].createElement("div", {
        className: "row text-white"
      }, _react["default"].createElement("div", {
        className: "col-lg-6"
      }, _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        }
      }, _react["default"].createElement("h3", null, "General Info"), _react["default"].createElement("hr", null), _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "Full Name:"), _react["default"].createElement("dd", null, device.user.fullName), _react["default"].createElement("dt", null, "Email:"), _react["default"].createElement("dd", null, device.user.email), _react["default"].createElement("dt", null, "Mobile:"), _react["default"].createElement("dd", null, device.user.mobile), _react["default"].createElement("dt", null, "Date of birth:"), _react["default"].createElement("dd", null, _DateHelper["default"].date(device.user.birthDay, 'D / MMMM / Y')), _react["default"].createElement("dt", null, "Address One:"), _react["default"].createElement("dd", null, device.user.addressOne), _react["default"].createElement("dt", null, "Address Two:"), _react["default"].createElement("dd", null, device.user.addressTwo), _react["default"].createElement("dt", null, "City:"), _react["default"].createElement("dd", null, device.user.city), _react["default"].createElement("dt", null, "Country:"), _react["default"].createElement("dd", null, device.user.countryName)))), _react["default"].createElement("div", {
        className: "col-lg-6"
      }, _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        }
      }, _react["default"].createElement("h3", null, "App Info"), _react["default"].createElement("hr", null), _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "Vip:"), _react["default"].createElement("dd", null, _react["default"].createElement(_AppActiveSign["default"], {
        value: device.user.isVip
      })), _react["default"].createElement("dt", null, "KYC Status:"), _react["default"].createElement("dd", null, device.user.kycStatus), _react["default"].createElement("dt", null, "Status:"), _react["default"].createElement("dd", null, device.user.status), _react["default"].createElement("dt", null, "Push Notifications:"), _react["default"].createElement("dd", null, device.user.pushNotifications), _react["default"].createElement("dt", null, "Unread Notifications:"), _react["default"].createElement("dd", null, device.user.unreadNotifications), _react["default"].createElement("dt", null, "Email Notifications:"), _react["default"].createElement("dd", null, device.user.emailNotifications)))))))))));
    }
  }]);

  return UserInfo;
}(_react.Component);

exports["default"] = UserInfo;